var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp-list-inquiry-firstname"},[_c('span',[_vm._v(_vm._s(_vm.computedFirstname))]),(_vm.reviewFor)?[_c('span',{attrs:{"title":("Zugeteilt von " + _vm.reviewFor)}},[_c('Icon',{attrs:{"name":"transfer"}})],1)]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }